import { useEffect, useState } from 'react';

import bookingAPI from '../../services/api/booking-documents';
import { IBooking } from '../ts/booking';

const useBookingData = (bookingId: string | null): IBooking | null => {
  const [bookingData, setBookingData] = useState<IBooking | null>(null);

  useEffect(() => {
    if (bookingId) {
      const getBookingData = async () => {
        try {
          const booking = await bookingAPI.getBookingById(bookingId);

          setBookingData(booking);
        } catch (err) {
          console.error(err);
        }
      };

      getBookingData();
    }
  }, [bookingId]);

  return bookingData;
};

export default useBookingData;
